import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSearchQuery, IQueryParams } from "../../../common";
import { ITemplate } from "./templates.types";
import { axios_api, server_base_endpoints } from "../../../api";
import { ISelectOption } from "../../../constants/types";
import { formatText } from "../../../helpers";


const templates = server_base_endpoints.templates

export const fetchMultipleTemplatesAsync = createAsyncThunk<{ data: ITemplate[], count: number }>(
    "templates/fetchMultipleTemplatesAsync", async () => {
        const response = await axios_api.get(`${templates.get_templates}`);
        const data: ITemplate[] = response.data.data;
        const count = response.data.totalRecords;
        return { data, count };
    });

export const fetchMultipleTemplatesWithArgsAsync = createAsyncThunk<{ data: ITemplate[], count: number }, IQueryParams>(
    'template/fetchMultipleTemplatesWithArgsAsync', async (queryParams: IQueryParams) => {
        const searchQuery = getSearchQuery(queryParams);
        const response = await axios_api.get(`${templates.get_templates}${searchQuery}`)
        return response.data as { data: ITemplate[], count: number }
    },
)

export const fetchSingleTemplateAsync = createAsyncThunk<ITemplate, string>(
    'template/fetchSingleTemplateAsync', async (uuid: string, thunkAPI) => {
        const response = await axios_api.get(`${templates.get_templates}?template_code=${uuid}`)
        return response.data
    },
)


export const upsertSingleTemplateAsync = createAsyncThunk<ITemplate, ITemplate>(
    'template/upsertSingleTemplateAsync', async (payload, thunkAPI) => {
        const response = await axios_api.post(templates.upsert_template, payload)
        // thunkAPI.dispatch(fetchMultipleTemplatesAsync({
        //     page: 1,
        //     rowsPerPage: 10
        // }))
        return response.data
    },
)



export const fetchTemplateSQLViewAndColumnsAsync = createAsyncThunk<ISelectOption[], { onCallback: (modules: ISelectOption[]) => void, tableName?: string, }>(
    'template/fetchTemplateSQLViewAndColumnsAsync', async ({ tableName, onCallback }, thunkAPI) => {
        try {
            let base_url = `${server_base_endpoints.templates.get_sql_view_or_columns}?table_type=VIEW`
            if (tableName) {
                base_url += "?templates_dynamic_views_code=" + tableName;
            }
            const response = await axios_api.get(base_url)

            const data: string[] = response.data.data;
            const finalData: ISelectOption[] = data.map((item) => ({ label: formatText(item), value: item }))
            if (!tableName) {
                const data: { "view_for": string; "templates_dynamic_views_code": string; }[] = response.data.data;
                const finalData = data.map((item) => ({ label: formatText(item.view_for), value: item.templates_dynamic_views_code }))
                onCallback(finalData);

            }
            else {
                const data: string[] = response.data.data;
                const finalData = data.map((item) => ({ label: item, value: item }))
                onCallback(finalData);
            }
            return finalData; // ✅ Ensure the function returns the expected value
        } catch (err: any) {
            onCallback([]);
            return thunkAPI.rejectWithValue(err.message || "Failed to fetch data");
        }
    },
)